import type React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface User {
  email: string | null;
  first_name: string | null;
  last_name: string | null;
}

interface AuditFooterProps {
  createdBy: User | null;
  lastUpdatedBy: User | null | string;
}

const AuditFooter: React.FC<AuditFooterProps> = ({
  createdBy,
  lastUpdatedBy,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  if (!createdBy && !lastUpdatedBy) {
    return null;
  }

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      sx={{
        width: "100%",
        padding: "16px 24px",
        marginTop: "20px",
        backgroundColor: reduxTheme.primary_colors?.[900] || "#f8f8f8",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        borderRadius: "8px",
      }}
    >
      {createdBy && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Typography
            variant="caption"
            color={reduxTheme.neutral_colors?.[100]}
            sx={{ fontWeight: "medium" }}
          >
            Created By
          </Typography>
          <Tooltip title={createdBy.email || ""} placement="top">
            <Typography
              variant="body2"
              color={reduxTheme.primary_colors?.[400] || "#fff"}
              sx={{ fontWeight: "bold" }}
            >
              {createdBy.first_name} {createdBy.last_name}
            </Typography>
          </Tooltip>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography
          variant="caption"
          color={reduxTheme.neutral_colors?.[100]}
          sx={{ fontWeight: "medium" }}
        >
          Last Updated By
        </Typography>

        {lastUpdatedBy && typeof lastUpdatedBy !== "string" ? (
          <Tooltip title={lastUpdatedBy.email || ""} placement="top">
            <Typography
              variant="body2"
              color={reduxTheme.primary_colors?.[400]}
              sx={{ fontWeight: "bold" }}
            >
              {lastUpdatedBy.first_name} {lastUpdatedBy.last_name}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            variant="body2"
            color={reduxTheme.primary_colors?.[400]}
            sx={{ fontWeight: "bold" }}
          >
            —
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AuditFooter;
